import {dibadminApi as api} from "./emptyDibadminApi";
export const addTagTypes = ["collections", "history", "Portal"] as const;
const injectedRtkApi = api
    .enhanceEndpoints({
        addTagTypes,
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getApiCollections: build.query<
                GetApiCollectionsApiResponse,
                GetApiCollectionsApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/collections`,
                    params: {
                        topicId: queryArg.topicId,
                    },
                }),
                providesTags: ["collections"],
            }),
            getApiHistory: build.query<
                GetApiHistoryApiResponse,
                GetApiHistoryApiArg
            >({
                query: () => ({url: `/api/history`}),
                providesTags: ["history"],
            }),
            getApiPortal: build.query<
                GetApiPortalApiResponse,
                GetApiPortalApiArg
            >({
                query: () => ({url: `/api/Portal`}),
                providesTags: ["Portal"],
            }),
            getApiPortalFull: build.query<
                GetApiPortalFullApiResponse,
                GetApiPortalFullApiArg
            >({
                query: () => ({url: `/api/Portal/full`}),
                providesTags: ["Portal"],
            }),
            getApiPortalByLanguage: build.query<
                GetApiPortalByLanguageApiResponse,
                GetApiPortalByLanguageApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/${queryArg.language}`,
                }),
                providesTags: ["Portal"],
            }),
            postApiPortalWidget: build.mutation<
                PostApiPortalWidgetApiResponse,
                PostApiPortalWidgetApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/widget`,
                    method: "POST",
                    body: queryArg.portalWidgetCreateRequest,
                }),
                invalidatesTags: ["Portal"],
            }),
            getApiPortalWidgetById: build.query<
                GetApiPortalWidgetByIdApiResponse,
                GetApiPortalWidgetByIdApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/widget/${queryArg.id}`,
                }),
                providesTags: ["Portal"],
            }),
            putApiPortalWidgetById: build.mutation<
                PutApiPortalWidgetByIdApiResponse,
                PutApiPortalWidgetByIdApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/widget/${queryArg.id}`,
                    method: "PUT",
                    body: queryArg.portalWidgetUpdateRequest,
                }),
                invalidatesTags: ["Portal"],
            }),
            deleteApiPortalWidgetById: build.mutation<
                DeleteApiPortalWidgetByIdApiResponse,
                DeleteApiPortalWidgetByIdApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/widget/${queryArg.id}`,
                    method: "DELETE",
                }),
                invalidatesTags: ["Portal"],
            }),
            postApiPortalWidgetReorder: build.mutation<
                PostApiPortalWidgetReorderApiResponse,
                PostApiPortalWidgetReorderApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/widget/reorder`,
                    method: "POST",
                    body: queryArg.body,
                }),
                invalidatesTags: ["Portal"],
            }),
            postApiPortalFilter: build.mutation<
                PostApiPortalFilterApiResponse,
                PostApiPortalFilterApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/filter`,
                    method: "POST",
                    body: queryArg.portalFilterCreateRequest,
                }),
                invalidatesTags: ["Portal"],
            }),
            getApiPortalFilterById: build.query<
                GetApiPortalFilterByIdApiResponse,
                GetApiPortalFilterByIdApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/filter/${queryArg.id}`,
                }),
                providesTags: ["Portal"],
            }),
            putApiPortalFilterById: build.mutation<
                PutApiPortalFilterByIdApiResponse,
                PutApiPortalFilterByIdApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/filter/${queryArg.id}`,
                    method: "PUT",
                    body: queryArg.portalFilterUpdateRequest,
                }),
                invalidatesTags: ["Portal"],
            }),
            deleteApiPortalFilterById: build.mutation<
                DeleteApiPortalFilterByIdApiResponse,
                DeleteApiPortalFilterByIdApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/filter/${queryArg.id}`,
                    method: "DELETE",
                }),
                invalidatesTags: ["Portal"],
            }),
            getApiPortalGrouping: build.query<
                GetApiPortalGroupingApiResponse,
                GetApiPortalGroupingApiArg
            >({
                query: () => ({url: `/api/Portal/grouping`}),
                providesTags: ["Portal"],
            }),
            postApiPortalGrouping: build.mutation<
                PostApiPortalGroupingApiResponse,
                PostApiPortalGroupingApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/grouping`,
                    method: "POST",
                    body: queryArg.portalGroupingCreateRequest,
                }),
                invalidatesTags: ["Portal"],
            }),
            getApiPortalGroupingById: build.query<
                GetApiPortalGroupingByIdApiResponse,
                GetApiPortalGroupingByIdApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/grouping/${queryArg.id}`,
                }),
                providesTags: ["Portal"],
            }),
            putApiPortalGroupingById: build.mutation<
                PutApiPortalGroupingByIdApiResponse,
                PutApiPortalGroupingByIdApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/grouping/${queryArg.id}`,
                    method: "PUT",
                    body: queryArg.portalGroupingUpdateRequest,
                }),
                invalidatesTags: ["Portal"],
            }),
            deleteApiPortalGroupingById: build.mutation<
                DeleteApiPortalGroupingByIdApiResponse,
                DeleteApiPortalGroupingByIdApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/grouping/${queryArg.id}`,
                    method: "DELETE",
                }),
                invalidatesTags: ["Portal"],
            }),
            postApiPortalGroupingReorder: build.mutation<
                PostApiPortalGroupingReorderApiResponse,
                PostApiPortalGroupingReorderApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/grouping/reorder`,
                    method: "POST",
                    body: queryArg.body,
                }),
                invalidatesTags: ["Portal"],
            }),
            getApiPortalProduktinfo: build.query<
                GetApiPortalProduktinfoApiResponse,
                GetApiPortalProduktinfoApiArg
            >({
                query: () => ({url: `/api/Portal/produktinfo`}),
                providesTags: ["Portal"],
            }),
            getApiPortalInvalidLinks: build.query<
                GetApiPortalInvalidLinksApiResponse,
                GetApiPortalInvalidLinksApiArg
            >({
                query: () => ({url: `/api/Portal/invalid-links`}),
                providesTags: ["Portal"],
            }),
            deleteApiPortalInvalidLinksById: build.mutation<
                DeleteApiPortalInvalidLinksByIdApiResponse,
                DeleteApiPortalInvalidLinksByIdApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/Portal/invalid-links/${queryArg.id}`,
                    method: "DELETE",
                }),
                invalidatesTags: ["Portal"],
            }),
        }),
        overrideExisting: false,
    });
export {injectedRtkApi as dibadminApi};
export type GetApiCollectionsApiResponse =
    /** status 200 Returns the user's collection fillings. */ CollectionHistoryResultDto;
export type GetApiCollectionsApiArg = {
    /** Optional topic ID to filter collections by. */
    topicId?: string;
};
export type GetApiHistoryApiResponse =
    /** status 200 Returns the user's navigation history. */ SetDto;
export type GetApiHistoryApiArg = void;
export type GetApiPortalApiResponse = /** status 200 OK */ Portal[];
export type GetApiPortalApiArg = void;
export type GetApiPortalFullApiResponse = /** status 200 OK */ string;
export type GetApiPortalFullApiArg = void;
export type GetApiPortalByLanguageApiResponse = /** status 200 OK */ string;
export type GetApiPortalByLanguageApiArg = {
    /** Language code (no, se, dk, en) */
    language: string;
};
export type PostApiPortalWidgetApiResponse =
    /** status 201 Created */ CreatedIdResponse;
export type PostApiPortalWidgetApiArg = {
    portalWidgetCreateRequest: PortalWidgetCreateRequest;
};
export type GetApiPortalWidgetByIdApiResponse =
    /** status 200 OK */ PortalWidget;
export type GetApiPortalWidgetByIdApiArg = {
    id: number;
};
export type PutApiPortalWidgetByIdApiResponse = unknown;
export type PutApiPortalWidgetByIdApiArg = {
    id: number;
    portalWidgetUpdateRequest: PortalWidgetUpdateRequest;
};
export type DeleteApiPortalWidgetByIdApiResponse = unknown;
export type DeleteApiPortalWidgetByIdApiArg = {
    id: number;
};
export type PostApiPortalWidgetReorderApiResponse = unknown;
export type PostApiPortalWidgetReorderApiArg = {
    body: PortalWidgetReorderItem[];
};
export type PostApiPortalFilterApiResponse =
    /** status 201 Created */ CreatedIdResponse;
export type PostApiPortalFilterApiArg = {
    portalFilterCreateRequest: PortalFilterCreateRequest;
};
export type GetApiPortalFilterByIdApiResponse =
    /** status 200 OK */ PortalFilter;
export type GetApiPortalFilterByIdApiArg = {
    id: number;
};
export type PutApiPortalFilterByIdApiResponse = unknown;
export type PutApiPortalFilterByIdApiArg = {
    id: number;
    portalFilterUpdateRequest: PortalFilterUpdateRequest;
};
export type DeleteApiPortalFilterByIdApiResponse = unknown;
export type DeleteApiPortalFilterByIdApiArg = {
    id: number;
};
export type GetApiPortalGroupingApiResponse =
    /** status 200 OK */ PortalGrouping[];
export type GetApiPortalGroupingApiArg = void;
export type PostApiPortalGroupingApiResponse =
    /** status 201 Created */ CreatedIdResponse;
export type PostApiPortalGroupingApiArg = {
    /** Grouping data */
    portalGroupingCreateRequest: PortalGroupingCreateRequest;
};
export type GetApiPortalGroupingByIdApiResponse =
    /** status 200 OK */ PortalGrouping;
export type GetApiPortalGroupingByIdApiArg = {
    /** Grouping ID */
    id: number;
};
export type PutApiPortalGroupingByIdApiResponse = unknown;
export type PutApiPortalGroupingByIdApiArg = {
    /** Grouping ID */
    id: number;
    /** Updated grouping data */
    portalGroupingUpdateRequest: PortalGroupingUpdateRequest;
};
export type DeleteApiPortalGroupingByIdApiResponse = unknown;
export type DeleteApiPortalGroupingByIdApiArg = {
    /** Grouping ID */
    id: number;
};
export type PostApiPortalGroupingReorderApiResponse = unknown;
export type PostApiPortalGroupingReorderApiArg = {
    /** List of grouping IDs with new display orders */
    body: PortalGroupingReorderItem[];
};
export type GetApiPortalProduktinfoApiResponse =
    /** status 200 OK */ ProduktInfo[];
export type GetApiPortalProduktinfoApiArg = void;
export type GetApiPortalInvalidLinksApiResponse =
    /** status 200 OK */ InvalidPortalWidgetLink[];
export type GetApiPortalInvalidLinksApiArg = void;
export type DeleteApiPortalInvalidLinksByIdApiResponse = unknown;
export type DeleteApiPortalInvalidLinksByIdApiArg = {
    id: number;
};
export type CollectionHistoryItemDto = {
    topicId?: string | null;
    collectionId?: string | null;
    title?: string | null;
    isOwner?: boolean;
    name?: string | null;
    desctiption?: string | null;
    published?: boolean;
    lastuse?: string;
    supplier?: string | null;
    type?: string | null;
    view?: string | null;
    language?: string | null;
    description?: string | null;
};
export type CollectionHistoryResultDto = {
    count?: number;
    items?: CollectionHistoryItemDto[] | null;
};
export type TopicSectionDetailDto = {
    sectionId?: string | null;
    sectionTitle?: string | null;
};
export type TopicSearchDetailDto = {
    id?: string | null;
    title?: string | null;
    isSegment?: boolean;
    sections?: TopicSectionDetailDto[] | null;
    score?: number;
    tocParentIds?: string[] | null;
};
export type ItemDto = {
    score?: number;
    id?: string | null;
    type?: string | null;
    supplier?: string | null;
    name?: string | null;
    view?: string | null;
    resourceTypeId?: string | null;
    language?: string | null;
    description?: string | null;
    published?: boolean;
    databases?: string[] | null;
    date?: string | null;
    lastuse?: string | null;
    collectionId?: string | null;
    collectionName?: string | null;
    segment_id?: string | null;
    section_id?: string | null;
    topicSearchDetail?: TopicSearchDetailDto[] | null;
};
export type SetDto = {
    offset?: number;
    count?: number;
    column?: number | null;
    items?: ItemDto[] | null;
};
export type Portal = {
    /** Portal ID */
    id?: number;
    /** Language code (no, se, dk, en) */
    language?: string | null;
    /** Creation timestamp */
    created_at?: string;
    /** Last update timestamp */
    updated_at?: string;
};
export type CreatedIdResponse = {
    /** ID of created resource */
    id?: number;
};
export type PortalWidgetCreateRequest = {
    /** Portal ID to attach widget to */
    portal_id: number;
    /** Widget title */
    title: string;
    /** Optional URL for the title link */
    title_url?: string | null;
    /** Widget description/content */
    description?: string | null;
    /** Whether widget is visible */
    is_enabled?: boolean;
    /** Display order (lower = first) */
    display_order?: number;
    /** JSON array of links: [{title, url}] */
    links?: string | null;
    /** JSON array of condition arrays: [[dbId, ...], ...] */
    conditions?: string | null;
};
export type PortalWidget = {
    /** Widget ID */
    id?: number;
    /** Parent portal ID */
    portal_id?: number;
    /** Widget title */
    title?: string | null;
    /** Optional URL for the title link */
    title_url?: string | null;
    /** Resolved absolute URL for the title link */
    title_target_url?: string | null;
    /** Widget description/content */
    description?: string | null;
    /** Whether widget is visible */
    is_enabled?: boolean;
    /** Display order (lower = first) */
    display_order?: number;
    /** JSON array of links: [{title, url}] */
    links?: string | null;
    /** JSON array of condition arrays: [[dbId, ...], ...] */
    conditions?: string | null;
    /** Creation timestamp */
    created_at?: string;
    /** Last update timestamp */
    updated_at?: string;
};
export type PortalWidgetUpdateRequest = {
    /** Widget title */
    title: string;
    /** Optional URL for the title link */
    title_url?: string | null;
    /** Widget description/content */
    description?: string | null;
    /** Whether widget is visible */
    is_enabled?: boolean;
    /** Display order (lower = first) */
    display_order?: number;
    /** JSON array of links: [{title, url}] */
    links?: string | null;
    /** JSON array of condition arrays: [[dbId, ...], ...] */
    conditions?: string | null;
    /** Optional JSON array of invalid link IDs to delete */
    invalid_links_to_delete?: string | null;
};
export type PortalWidgetReorderItem = {
    /** Widget ID */
    id: number;
    /** New display order */
    display_order: number;
};
export type PortalFilterCreateRequest = {
    /** Portal ID to attach filter to */
    portal_id: number;
    /** Filter name */
    name: string;
    /** JSON array of condition arrays: [[dbId, ...], ...] */
    conditions?: string | null;
};
export type PortalFilter = {
    /** Filter ID */
    id?: number;
    /** Parent portal ID */
    portal_id?: number;
    /** Filter name */
    name?: string | null;
    /** JSON array of condition arrays: [[dbId, ...], ...] */
    conditions?: string | null;
    /** Creation timestamp */
    created_at?: string;
    /** Last update timestamp */
    updated_at?: string;
};
export type PortalFilterUpdateRequest = {
    /** Filter name */
    name: string;
    /** JSON array of condition arrays: [[dbId, ...], ...] */
    conditions?: string | null;
};
export type PortalGrouping = {
    /** Grouping ID */
    id?: number;
    /** Grouping name */
    name?: string | null;
    /** Display order (lower = first) */
    display_order?: number;
    /** JSON array of product IDs in this grouping */
    products_json?: string | null;
    /** JSON array of product IDs that must be included */
    must_include_json?: string | null;
    /** JSON array of product IDs that must be excluded */
    must_exclude_json?: string | null;
};
export type PortalGroupingCreateRequest = {
    /** Grouping name */
    name: string;
    /** Display order (lower = first) */
    display_order?: number;
    /** JSON array of product IDs */
    products_json?: string | null;
    /** JSON array of must-include product IDs */
    must_include_json?: string | null;
    /** JSON array of must-exclude product IDs */
    must_exclude_json?: string | null;
};
export type PortalGroupingUpdateRequest = {
    /** Grouping name */
    name: string;
    /** Display order (lower = first) */
    display_order?: number;
    /** JSON array of product IDs */
    products_json?: string | null;
    /** JSON array of must-include product IDs */
    must_include_json?: string | null;
    /** JSON array of must-exclude product IDs */
    must_exclude_json?: string | null;
};
export type PortalGroupingReorderItem = {
    /** Grouping ID */
    id: number;
    /** New display order */
    display_order: number;
};
export type ProduktInfo = {
    /** Product ID */
    id?: number;
    /** Product tag identifier */
    tag_id?: string | null;
    /** Product name */
    navn?: string | null;
};
export type InvalidPortalWidgetLink = {
    id?: number;
    portal_id?: number;
    widget_id?: number;
    raw_url?: string | null;
    created_at?: string;
};
export const {
    useGetApiCollectionsQuery,
    useGetApiHistoryQuery,
    useGetApiPortalQuery,
    useGetApiPortalFullQuery,
    useGetApiPortalByLanguageQuery,
    usePostApiPortalWidgetMutation,
    useGetApiPortalWidgetByIdQuery,
    usePutApiPortalWidgetByIdMutation,
    useDeleteApiPortalWidgetByIdMutation,
    usePostApiPortalWidgetReorderMutation,
    usePostApiPortalFilterMutation,
    useGetApiPortalFilterByIdQuery,
    usePutApiPortalFilterByIdMutation,
    useDeleteApiPortalFilterByIdMutation,
    useGetApiPortalGroupingQuery,
    usePostApiPortalGroupingMutation,
    useGetApiPortalGroupingByIdQuery,
    usePutApiPortalGroupingByIdMutation,
    useDeleteApiPortalGroupingByIdMutation,
    usePostApiPortalGroupingReorderMutation,
    useGetApiPortalProduktinfoQuery,
    useGetApiPortalInvalidLinksQuery,
    useDeleteApiPortalInvalidLinksByIdMutation,
} = injectedRtkApi;
